import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

interface TicketingProviderIds {
  asanaRadioId: string;
  jiraRadioId: string;
  jiraDataCenterRadioId: string;
  linearRadioId: string;
  trelloRadioId: string;
  githubRadioId: string;
  shortcutRadioId: string;
}

export const useTicketingProviderIds = (): TicketingProviderIds => ({
  asanaRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_ASANA),
  jiraRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_JIRA),
  jiraDataCenterRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_JIRA_DATA_CENTER),
  linearRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_LINEAR),
  trelloRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_TRELLO),
  githubRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_GITHUB),
  shortcutRadioId: useAnalyticId(AnalyticIdentifier.RTC_SELECT_LINK_SHORTCUT),
});
